import { Component,Input } from '@angular/core';
import { IntUser, PafSetting, SharedDataService } from 'ngx-paf-common';
import {  Router } from '@angular/router';

@Component({
  selector: 'paf-header',
  templateUrl: './paf-header.component.html',
  styleUrls: ['./paf-header.component.scss']
})
export class PafHeaderComponent {
  isMenuCollapsed = true;
  closeMenuOnMobile(): void {
    this.isMenuCollapsed = true;
  }
  @Input() intUser?: IntUser = null;
  constructor(
    private router: Router,
    public sharedDatasSvc:SharedDataService
  ) { }
  

  public async connect(){
    this.router.navigate(['login']);
  }
  get ProfilCod(): string {
    return this.sharedDatasSvc.profil?.Cod;
  }

  get listMenuNotEmpty(): boolean {
    return this.canAccessMyTasks() || this.canAccessDocLists() || this.canAccessEncours();
  }

  canAccessTakapa():boolean {
    return this.sharedDatasSvc.checkProfilAccessPafSettings('TAKAPA');
  }
  canAccessMyTasks():boolean {
    return this.sharedDatasSvc.checkProfilAccessPafSettings('MY_TASKS');
  }

  canAccessNewSupplier():boolean {
    return this.sharedDatasSvc.checkProfilAccessPafSettings('NEW_SUPPLIER');
  }

  canAccessDocLists():boolean {
    return this.sharedDatasSvc.checkProfilAccessPafSettings('DOC_LISTS');
  }

  canAccessIntUsersAdmin():boolean {
    return this.sharedDatasSvc.checkProfilAccessPafSettings('INTERNAL_USERS');
  }

  canAccessSourcing():boolean {
    return this.sharedDatasSvc.checkProfilAccessPafSettings('SOURCING');
  }
  
  canAccessEncours():boolean {
    return this.sharedDatasSvc.checkProfilAccessPafSettings('EN_COURS');
    
  }
  
  canAccessPBI():boolean {
    return this.sharedDatasSvc.checkProfilAccessPafSettings('PBI') && this.PBI_Url != undefined;    
  }

  get isDebug():boolean {
    return this.sharedDatasSvc.pafEnvironment?.debug;
  }


  get pafSettings(): PafSetting[] | undefined {
    return this.sharedDatasSvc?.pafSettings;
  }


  get PBI_Url():string | undefined {
    if (this.pafSettings){
        let url =  this.sharedDatasSvc.pafSettings.find((setting:PafSetting)=>setting.KEY=='PBI_URL')?.VALUE;
        let message = this.sharedDatasSvc.pafSettings.find((setting:PafSetting)=>setting.KEY=='YMO-Message')?.VALUE; 
        if (this.sharedDatasSvc.pafEnvironment.debug && !!message) return 'ymo-message';
        return url;
    }
    else {
        return undefined;
    }
  }

  get pafTitle():string {
    return this.sharedDatasSvc.lngCod =='EN' ? 'Suppliers Portal' : 'Portail fournisseurs';
  }
  
}
